
import { createComponent } from "@front/utils/alpine";

export default createComponent(() => ({
    setup() {
        const input = document.querySelector('.js-filter-input') as HTMLInputElement;
        const elements = document.querySelectorAll('.js-filter-item a');
        
        input.addEventListener('keyup', (e) => {
            if(input.value != '') {
                const items = document.querySelectorAll('.js-filter-item a[data-name^="'+input.value.toUpperCase()+'"]');

                elements.forEach((item) => {
                    const parent = item.parentNode as HTMLElement;
                    parent.classList.add('hidden');
                });

                items.forEach((item) => {
                    const parent = item.parentNode as HTMLElement;
                    parent.classList.remove('hidden');
                });
            } else {
                elements.forEach((item) => {
                    const parent = item.parentNode as HTMLElement;
                    parent.classList.remove('hidden');
                });
            }
        })
    },
}));